var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPending(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3013 5.3655C10.4823 4.5465 9.41134 4.1335 8.33334 4.1335V8.3335L5.36534 11.3015C7.00334 12.9395 9.66334 12.9395 11.3083 11.3015C12.9463 9.6635 12.9463 7.0035 11.3013 5.3655ZM8.33334 1.3335C4.46934 1.3335 1.33334 4.4695 1.33334 8.3335C1.33334 12.1975 4.46934 15.3335 8.33334 15.3335C12.1973 15.3335 15.3333 12.1975 15.3333 8.3335C15.3333 4.4695 12.1973 1.3335 8.33334 1.3335ZM8.33334 13.9335C5.23934 13.9335 2.73334 11.4275 2.73334 8.3335C2.73334 5.2395 5.23934 2.7335 8.33334 2.7335C11.4273 2.7335 13.9333 5.2395 13.9333 8.3335C13.9333 11.4275 11.4273 13.9335 8.33334 13.9335Z",
    fill: "#C058FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.12489980d1f301274b0c453c6664ad17.svg";
export { ForwardRef as ReactComponent };